import { combineReducers } from 'redux';
import {
    VALIDATOR_STATS_FETCH_ERROR,
    VALIDATOR_STATS_FETCH_IN_PROGRESS,
    VALIDATOR_STATS_FETCH_SUCCESS,
} from '../constants/validators';

const stats = (state = {
    inProgress: false,
    value: {},
}, action) => {
    switch (action.type) {
    case VALIDATOR_STATS_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case VALIDATOR_STATS_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case VALIDATOR_STATS_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

export default combineReducers({
    stats,
});
